<template>
    <div class="_content">
        <div v-if="this.userRole === '老板' || this.userRole === '店长' || this.userRole === '员工' ">
            <!-- 开启 -->
            <div v-if="shopServiceData.signStatus == 1 " class="serve_open">
                <div  class="shopserve_list">
                    <div><span>服务名称</span><span>{{shopServiceData.secondClassName}}</span></div>
                    <div><span>服务状态</span><span class="shopserve_list_open">已开启</span></div>
                    <div><span>结算价格</span><span>￥ {{shopServiceData.signPrice}}</span></div>
                    <div><span>合计销量</span><span>{{shopServiceData.salesNum}}</span></div>
                </div>
                <van-button
                    @click="handleClick(tabList1[0])"
                    class="closeserve_btn"
                    type="danger"
                    size="large"
                    :disabled="isDisabled"
                >关闭服务</van-button>
            </div>
            <!-- 关闭 -->
            <div v-else class="serve_close">
                <div  class="shopserve_list">
                    <div><span>服务名称</span><span>{{shopServiceData.secondClassName}}</span></div>
                    <div><span>服务状态</span><span>已关闭</span></div>
                    <div><span>结算价格</span><span>￥ {{shopServiceData.signPrice}}</span></div>
                    <div><span>合计销量</span><span>{{shopServiceData.salesNum}}</span></div>
                </div>
                <van-button
                    v-call="{tel: (currentShopInfo.managerPhone ? currentShopInfo.managerPhone : '400-176-8848')}"
                    class="closeserve_btn" 
                    type="info"  
                    size="large" 
                >开启联系市场经理</van-button>            
            </div>
        </div>
        <!-- 异常错误 -->
        <van-empty 
            v-else-if="this.userRole === '' "
            image="error" 
            description="网络错误"
        />
    </div>
</template>
<script>
import config from '@/configs/config'
export default {
    data() {
        return {
            shopId: '',
            userRole: '',
            serveCode: 0,
            tabList1: [{
                name: '店铺服务',
                url: '/pages/shopService/index'
            }],
            shopServiceData: {},
            isDisabled: false
        }
    },
    computed: {
        currentShopInfo () {
            return tuhu.store.state.currentShopInfo
        }
    },
    created() {
        this.getUserInfo()
        this.shopServiceData = this.options.ServeInfo
        },
    methods: {
        async getUserInfo() {
            // 身份信息
            const roleData = await tuhu.fetch(`${config.apis.GET_USERINFO}`)
            console.log('roleData', roleData)
            if (roleData && roleData.code === '200') {
                console.log('roleData', roleData)
                this.userRole = roleData.data.role
                this.shopId = roleData.data.shopId
            } else {
                tuhu.toast(roleData.message || '获取权限信息失败')
            }
        },
        async handleClick (item) {
            // 关闭
            const data = await tuhu.fetch(`${config.apis.CLOSE_SERVICE}`, {
                method: 'post',
                body: JSON.stringify({
                    secondClassId: this.shopServiceData.secondClassId, // 二级分类id
                    shopId: this.shopId
                })
            })
            if (data && data.code === '200') {
                this.isDisabled = true
                // tuhu.navigateTo({url: item.url})
                tuhu.navigateBack()
            } else {
                tuhu.toast(data.message || '网络错误')
            }
        }
    }
}
</script>
<style lang="less" scoped>
    .shopserve_list{
        width: 100%;
        height: 8rem;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        padding:.5rem;
        >div{
            display:flex;
            justify-content: space-between
        }
    }
    .closeserve_btn{
        .van-button__text{
            color:white
        }
    }
    .shopserve_list_open{
        color: rgb(25,137,250);
    }
    .serve_open{
        display: flex;
        flex-direction: column;
    }
    .serve_close{
        display: flex;
        flex-direction: column;
    }
    .shopserve_list{
        background: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/pages/shopServeClose/index.vue